import { useQuery } from "@tanstack/react-query";

export interface MissingField {
  fieldKey: string;
  label: string;
}

export interface CardReadiness {
  cardId: string;
  cardName: string;
  tab: string;
  basicMissing: MissingField[];
  comprehensiveMissing: MissingField[];
}

export interface ReadinessReport {
  basicModuleComplete: boolean;
  comprehensiveModuleComplete: boolean;
  basicMissingCount: number;
  comprehensiveMissingCount: number;
  cards: CardReadiness[];
}

async function fetchReadiness(assessmentId: string): Promise<ReadinessReport> {
  const response = await fetch(`/api/assessments/${assessmentId}/readiness`, {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error("Failed to fetch readiness report");
  }
  return response.json();
}

export function useReportReadiness(assessmentId: string | null, enabled = true) {
  return useQuery({
    queryKey: ["readiness", assessmentId],
    queryFn: () => fetchReadiness(assessmentId!),
    enabled: !!assessmentId && enabled,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
}
